import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import './registerServiceWorker'
import "./common/index.scss";
import "./common/amfe-flexible";
import { getQuery, bus, DB, axios, busMixin } from "./common";
import * as filters from "./common/filters";
import * as directives from "./common/directives";
import FastClick from "fastclick";
import PortalVue from "portal-vue";
import VueScrollStop from "vue-scroll-stop";

Vue.use(PortalVue);
Vue.use(VueScrollStop);

console.log('restart test client');

Vue.mixin(busMixin);
console.log("v2.1.0");

if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
  FastClick.attach(document.body);
  console.log("use fastclick");
}

Vue.config.productionTip = false;

let lang = getQuery("lang") || "en";
if (!["en", "jp", "zht"].includes(lang)) {
  lang = "en";
}
store.commit("setLang", lang);
store.dispatch("getBaseInfo");
store.dispatch("autoGetUserDate");
store.commit("runTime");
store.dispatch("getTornamentList");
store.dispatch("getLiveBroadcastList");
document.body.classList.add(`lang-${lang}`);

for (const filterName of Object.keys(filters)) {
  Vue.filter(filterName, filters[filterName]);
}

Vue.prototype.$filters = Vue.options.filters;

for (const directiveName of Object.keys(directives)) {
  Vue.directive(directiveName, directives[directiveName]);
}

window.handleNativeNotify = (event) => {
  bus.$emit(event.name, event);
  // new Image().src = '/notify/'+event.name + '/' + JSON.stringify(event)
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

axios.get(`/api/viewCount`);
// console.log(123123)
